export const UNWANTED_OR_SPAM = 'UNWANTED_OR_SPAM';
export const HARASSMENT_OR_BULLYING = 'HARASSMENT_OR_BULLYING';
export const INAPPROPRIATE_CONTENT = 'INAPPROPRIATE_CONTENT';
export const HATE_SPEECH_OR_GRAPHIC_VIOLENCE =
  'HATE_SPEECH_OR_GRAPHIC_VIOLENCE';
